// Запросы к серверу. Ошибку сервера показываем его же словами (поле detail).
import { noteVersion, VERSION_HEADER } from "./lib/version";

export class ApiError extends Error {
  constructor(message: string, readonly status: number) {
    super(message);
  }
}

export async function api(url: string, body?: unknown, method?: string): Promise<Response> {
  const options: RequestInit = { method: method || (body === undefined ? "GET" : "POST"), headers: {} };
  if (body !== undefined) {
    options.headers = { "Content-Type": "application/json" };
    options.body = JSON.stringify(body);
  }
  const response = await fetch(url, options);
  noteVersion(response.headers.get(VERSION_HEADER));   // сайт обновился, пока вкладка открыта
  if (!response.ok) {
    let message: unknown = "Что-то пошло не так. Попробуйте ещё раз.";
    try { message = (await response.json()).detail || message; } catch { /* ответ не JSON */ }
    throw new ApiError(typeof message === "string" ? message : "Проверьте введённые данные.", response.status);
  }
  return response;
}

export const getJson = async <T>(url: string): Promise<T> => (await api(url)).json();
export const postJson = async <T>(url: string, body: unknown, method?: string): Promise<T> => (await api(url, body, method)).json();

// Ответ сервера с файлом — в загрузки браузера под именем из Content-Disposition.
export async function saveResponse(response: Response, fallback: string) {
  const match = (response.headers.get("Content-Disposition") || "").match(/filename\*=UTF-8''([^;]+)/);
  saveBlob(await response.blob(), match ? decodeURIComponent(match[1]) : fallback);
}

export function saveBlob(blob: Blob, filename: string) {
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(link.href), 10000);
}

export async function downloadDocument(slug: string, answers: Record<string, string>) {
  await saveResponse(await api(`/api/templates/${slug}/render`, { answers }), "Документ.docx");
}
